import React, { useEffect, useRef } from 'react';
import {
  LoveIcon, SmileIcon, UsersIcon,
  ShieldIcon, WindIcon, MonitorIcon, ArrowUpRightIcon,
} from '../assets/icons/Icons';
import '../styles/services.css';

const servicesData = [
  {
    icon: <LoveIcon size={22} color="white" />,
    title: 'Psychiatric evaluation',
    desc: 'Comprehensive assessment, diagnosis, and management by certified psychiatrists.',
    featured: true,
  },
  {
    icon: <ShieldIcon size={20} />,
    title: 'De-addiction',
    desc: 'Specialised and structured treatment for substance use and behavioural addictions including tobacco, alcohol, cannabis, gaming and gambling.',
  },
  {
    icon: <ShieldIcon size={20} />,
    title: 'Women\'s mental health',
    desc: 'Care that is tailored to the unique emotional, hormonal and psychosocial challenges of women across every stage of life',
  },
  {
    icon: <WindIcon size={20} />,
    title: 'Child & adolescent',
    desc: 'Specialised care for young minds  facing emotional, academic or mental health challenges.',
  },
  {
    icon: <SmileIcon size={20} />,
    title: 'Individual therapy',
    desc: 'One-on-one sessions using evidence-based approaches including CBT, DBT, and trauma-focused therapy.',
  },
  {
    icon: <UsersIcon size={20} />,
    title: 'Couples & family',
    desc: 'Improve communication, strengthen relationships and navigate conflicts through evidence-based therapeutic approaches.',
  },
  {
    icon: <MonitorIcon size={20} />,
    title: 'Teams, professionals, and students',
    desc: 'Mental health programs, workshops and stress management modules for institutes and organisations.',
  },
];

const Services = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-up');
    elements?.forEach((el) => observer.observe(el));
    return () => elements?.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <section className="services-section" id="services" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-up">
          <span className="section-tag">Our services</span>
          <h2>Comprehensive mental health care</h2>
          <p>Combining medical expertise, psychotherapy and family support for lasting well-being</p>
        </div>

        <div className="services-bento fade-up">
          {servicesData.map((service, i) => (
            <div
              className={`service-card ${service.featured ? 'featured' : ''}`}
              key={i}
            >
              <div className="service-icon">{service.icon}</div>
              <div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
